<template>
  <div class="row q-col-gutter-y-md text-center">
    <div class="col-12 col-sm-6">
      <div class="text-h5">
        <image-count :filters="{ accountIds: [this.accountId]}" />
      </div>
      <div class="text-body1 text-uppercase">Images</div>
    </div>
    <div class="col-12 col-sm-6">
      <div class="text-h5">
        <video-count :filters="{ accountIds: [this.accountId]}" />
      </div>
      <div class="text-body1 text-uppercase">Videos</div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import ImageCount from '@/social/post/util/ImageCount.vue';
import VideoCount from '@/social/post/util/VideoCount.vue';

export default defineComponent({
  components: {
    ImageCount,
    VideoCount,
  },
  props: {
    accountId: {
      type: Number,
      required: true,
    },
  },
});
</script>
